import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBars3 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.84962 16H2.15038C1.51504 16 1 16.4141 1 16.9249V22.0751C1 22.5859 1.51504 23 2.15038 23H5.84962C6.48496 23 7 22.5859 7 22.0751V16.9249C7 16.4141 6.48496 16 5.84962 16Z",
			fill: "white",
			stroke: "#616161",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8496 11H10.1504C9.51504 11 9 11.3994 9 11.8921V22.1079C9 22.6006 9.51504 23 10.1504 23H13.8496C14.485 23 15 22.6006 15 22.1079V11.8921C15 11.3994 14.485 11 13.8496 11Z",
			fill: "white",
			stroke: "#616161",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8496 1H18.1504C17.515 1 17 1.40974 17 1.91517V22.0848C17 22.5903 17.515 23 18.1504 23H21.8496C22.485 23 23 22.5903 23 22.0848V1.91517C23 1.40974 22.485 1 21.8496 1Z",
			fill: "white",
			stroke: "#616161",
			strokeWidth: .5
		})
	]
});
const ForwardRef = forwardRef(SvgBars3);
export { ForwardRef as ReactComponent };
